import { motion, useAnimation, useAnimationFrame } from 'framer-motion';
import { useRef } from 'react';

const SPIN_DURATION = 12; // seconds

export function OrbitingChain({
  chain,
  children,
  radius,
  centerY,
}: {
  chain: any;
  children: any;
  radius: number;
  centerY: number;
}) {
  const controls = useAnimation();
  const initialAngle = chain.angle;
  const startTime = useRef<number | null>(null);

  useAnimationFrame(time => {
    if (!startTime.current) startTime.current = time;
    const elapsed = (time - startTime.current) / 1000; // Convert to seconds

    // Compute the angle based on elapsed time
    const angle = ((elapsed / SPIN_DURATION) * 360 + initialAngle) % 360;

    const newX = radius * Math.cos((angle * Math.PI) / 180);
    const newY = radius * Math.sin((angle * Math.PI) / 180) + centerY;

    controls.set({ x: newX, y: newY });
  });

  return (
    <motion.div
      initial={{
        x: radius * Math.cos((chain.angle * Math.PI) / 180),
        y: radius * Math.sin((chain.angle * Math.PI) / 180) + centerY,
        width: '60px',
        height: '60px',
        padding: '15px',
      }}
      animate={controls}
      className="main-page--hero-chain"
      style={{ ...chain.style, opacity: 1 }}
      transition={{
        type: 'spring',
        stiffness: 100,
        damping: 20,
      }}
    >
      {children}
    </motion.div>
  );
}
